// extracted by mini-css-extract-plugin
export default {"tabs":"CategoryTabs_tabs__wl5el","tab":"CategoryTabs_tab__fbYWV","active":"CategoryTabs_active__+w+7t"};